import clsx from 'clsx';
import React from 'react';

import styles from './Card.module.scss';

interface CardProps {
  title?: React.ReactNode;
  actions?: React.ReactNode;
  headLeft?: React.ReactNode;
  titleSize?: 'lg' | 'md';
  className?: string;
  headClassName?: string;
  as?: keyof JSX.IntrinsicElements;
  children?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
  title,
  actions,
  headLeft,
  titleSize = 'md',
  className,
  headClassName,
  as: Component = 'div',
  children,
}) => {
  const hasHead = !!(title || headLeft || actions);

  return (
    <Component className={clsx(styles.card, className)}>
      {hasHead && (
        <div className={clsx(styles.head, headClassName)}>
          <div className={styles.headLeft}>
            {title && <h3 className={clsx(styles.title, styles[`title-${titleSize}`])}>{title}</h3>}
            {headLeft}
          </div>
          {actions}
        </div>
      )}
      {children}
    </Component>
  );
};
